import React, {PropTypes} from 'react';
import {Button, Icon} from '@goguardian/based';
import {Link} from 'react-router'

import style from './style.scss';

export default class Begin extends React.Component {

  render() {
    return (
      <div className={style.step}>
        <div className={style.beginHeader}>
          <h2>Getting Started</h2>
        </div>

        <div className={style.beginContent}>
          <p>Welcome to GoGuardian. This guide will provide you with step by step instructions for deploying GoGuardian across your domain.</p>
          <p className={style.installTime}><strong><Icon value="clock"/> The installation will take about 5 mins</strong></p>
          <Link to="/getting-started/sign-in"><Button type="cta" block>Install GoGuardian</Button></Link>
        </div>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/components/gettingStarted/begin/index.jsx
 **/